<template>
  <div>
    <div class="row">
      <breadcrumb>
        <template v-slot:1>
          <router-link :to="{ name: 'informes' }">{{
            $t("informes")
          }}</router-link>
        </template>
        <template v-slot:2>{{ $t("facturasSimplificadas") }}</template>
      </breadcrumb>

      <CabeceraInformes
        v-if="sectores && $cookies.isKey('sectores')"
        :idBusiness="idBusiness"
        :listBusinesses="listBusinesses"
        :idTpv="idTpv"
        :listTpv="listTpv"
        :dateto="dateto"
        :datefrom="datefrom"
        id="cabecera"
        :conTodos="true"
        :sectores="true"
        :listSectores="listaSectores"
        :idSector="idSector"
      />
      <CabeceraInformes
        v-else
        :idBusiness="idBusiness"
        :listBusinesses="listBusinesses"
        :idTpv="idTpv"
        :listTpv="listTpv"
        :dateto="dateto"
        :datefrom="datefrom"
        id="cabecera"
        :conTodos="true"
      />
      <template v-if="!permiso">
          <div class="alert alert-danger m-3" style="width: 100%" role="alert">
              Lo sentimos. Este negocio no cuenta con este módulo activado.
          </div>
      </template>
      <div class="col-md-12" v-else-if="respuesta">
        <template v-if="dateInform.length > 0">
          <div class="row justify-content-between div-export">
            <div class="col-md-6">
              <el-dropdown>
                <el-button type="primary" size="small">
                  <i class="fa fa-file"></i>
                  {{ $t("exportarInforme") }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <a @click="exportForm('HTML','Simple')">
                    <el-dropdown-item class="text-primary">
                      <strong
                        ><i class="fa fa-file-code"></i>
                        {{ $t("exportarComoHTML") }}</strong
                      >
                    </el-dropdown-item>
                  </a>
                  <a @click="exportForm('HTML','Detalles')">
                    <el-dropdown-item class="text-primary">
                      <strong
                        ><i class="fa fa-file-code"></i>
                        {{ $t("exportarComoHTML") }} {{ $t("conDetalles") }}</strong
                      >
                    </el-dropdown-item>
                  </a>
                  <a @click="exportForm('Excel','Simple')">
                    <el-dropdown-item class="text-success">
                      <strong
                        ><i class="fa fa-file-excel"></i>
                        {{ $t("exportarExcel") }}</strong
                      >
                    </el-dropdown-item>
                  </a>
                  <a @click="exportForm('Excel','Detalles')">
                    <el-dropdown-item class="text-success">
                      <strong
                        ><i class="fa fa-file-excel"></i>
                        {{ $t("exportarExcel") }} {{ $t("conDetalles") }}</strong
                      >
                    </el-dropdown-item>
                  </a>

                  <!-- Funciona pero ahora esta en el informe de facturas -->
                  <!--<a @click="exportForm('Excel','Completo')">
                    <el-dropdown-item class="text-success">
                      <strong>
                        <i class="fa fa-file-excel"></i>
                        {{ $t("exportarExcelDeTodosLosTickets") }}</strong
                      >
                    </el-dropdown-item>
                  </a>-->

                </el-dropdown-menu>
              </el-dropdown>
              <el-switch
                v-if="existeProducto == true "  
                  style="margin-left:5%;"
                  v-model="checkValue"
                  active-color="#13ce66"
                  inactive-color="#bcbcbc"
                  @change="emitirConsulta()"
                >
                </el-switch>
                <label v-if="existeProducto == true ">
                  <strong>
                    {{$t('NoMostrarRecargasSaldo')}}
                  </strong>
                </label>
   
            </div>
           
            <div class="input-group col-md-6">
              <input
                type="text"
                class="form-control"
                :placeholder="$t('buscarTicket')"
                v-model="searchQuery"
                @keyup.enter.prevent="searchTickets"
              />
              <div class="input-group-append">
                <button style="margin-bottom:0px"
                  @click="searchTickets()"
                  class="btn btn-secondary"
                  type="button"
                >
                  <i class="fa fa-search"></i>
                </button>
                <button style="margin-bottom:0px"
                  @click="getTickets(), searchQuery=''"
                  class="btn btn-secondary"
                  type="button"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>
          </div>

          <div
            v-for="(obj, index) in dateInform"
            class="table-responsive"
            style="overflow: auto"
          >
            <strong>
              {{ obj.nameTpv }} {{ $t("cierre") }}:
              <span :class="getClassDay(obj.day)"
                >{{ obj.day | getDia }} {{ obj.day | parseDate }}
              </span></strong
            >

            <table class="table table-bordered table-striped text-nowrap">
              <thead class="thead-dark">
                <tr>
                  <th>
                    <span
                      v-if="ordenarFecha"
                      @click="sortedArrayASC(1, index), (ordenarFecha = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("fecha") }}
                    </span>
                    <span
                      v-else
                      @click="sortedArrayDESC(1, index), (ordenarFecha = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("fecha") }}
                    </span>
                  </th>
                  <th v-if="sectores && $cookies.isKey('sectores')">
                    <span
                      v-if="ordenarNombreTPV"
                      @click="sortedArrayASC(2, index), (ordenarNombreTPV = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("nombre") }} TPV
                    </span>
                    <span
                      v-else
                      @click="sortedArrayDESC(2, index), (ordenarNombreTPV = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("nombre") }} TPV
                    </span>
                  </th>
                  <th>
                    <span
                      v-if="ordenarFactura"
                      @click="sortedArrayASC(2, index), (ordenarFactura = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("factura") }}
                    </span>
                    <span
                      v-else
                      @click="sortedArrayDESC(2, index), (ordenarFactura = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("factura") }}
                    </span>
                  </th>
                  <th>
                    {{ $t("agencia") }}
                  </th>
                  <th>
                    <span
                      v-if="ordenarTipo"
                      @click="sortedArrayASC(3, index), (ordenarTipo = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("tipo") }}
                    </span>
                    <span
                      v-else
                      @click="sortedArrayDESC(3, index), (ordenarTipo = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("tipo") }}
                    </span>
                  </th>
                  <th>
                    {{ $t("comensales") }}
                  </th>
                  <th>
                    {{ $t("baseMayusculas") }}
                  </th>
                  <th>{{ $t("IVA") }}</th>
                  <th>
                    <span
                      v-if="ordenarTipo"
                      @click="sortedArrayASC(4, index), (ordenarTotal = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("total") }}
                    </span>
                    <span
                      v-else
                      @click="sortedArrayDESC(4, index), (ordenarTotal = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("total") }}
                    </span>
                  </th>
                  <!-- añado esta columna comprobar si ordena bien-->
                  <th style="width : 5%">
                    <span
                      v-if="ordenarTipo"
                      @click="sortedArrayASC(5, index), (ordernarTotalSinDescuento = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("totalSinDescuento") }}
                    </span>
                    <span
                      v-else
                      @click="sortedArrayDESC(5, index), (ordernarTotalSinDescuento = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("totalSinDescuento") }}
                    </span>
                  </th>
                  <th width="10%">{{ $t("acciones") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="det in obj.headers">
                  <td>
                    <span :class="getClassDay(det.date)"
                      >{{ det.date | getDia }}
                      {{ det.date | parseDateMin }}</span
                    >
                  </td>
                  <td v-if="sectores && $cookies.isKey('sectores')">{{ det.nameTPV }}</td>
                  <td>Nº {{ det.idCode }}</td>
                  <td v-if="det.nameAgencia">{{ det.nameAgencia }}</td>
                  <td v-else>--</td>
                  <td v-if="det.status === 'C'">{{ $t("cobrado") }}</td>
                  <td v-else-if="det.status === 'A'">{{ $t("aparcado") }}</td>
                  <td v-else-if="det.status === 'P'">{{ $t("pendiente") }}</td>
                  <td v-else-if="det.status === 'X'">{{ $t("cambio") }}</td>
                  <td v-else-if="det.status === 'N'">{{ $t("anulado") }}</td>
                  <td v-else-if="det.status === 'G'">{{ $t("gasto") }}</td>
                  <td>{{ det.comensales }}</td>
                  <td align="right" v-if="det.status === 'C'">
                    <template v-if="det.amount !== 0">{{
                      totalBase(det) | currency
                    }}</template>
                    <template v-else>{{ 0 | currency }}</template>
                  </td>
                  <td align="center" v-else>--</td>
                  <td align="right" v-if="det.status === 'C'">
                    <template v-if="det.amount !== 0">{{
                      totalImpuesto(det) | currency
                    }}</template>
                    <template v-else>{{ 0 | currency }}</template>
                  </td>
                  <td v-else align="center">--</td>
                  <td align="right">{{ calculateTotal(det) | currency }}</td>
                  <td v-if="det.nameProducto.startsWith('Recarga')" align="right"> {{ 0 | currency}} </td>
                  <td v-else align="right">{{calculateTotal(det) | currency}}</td>
                  <td align="center">
                    <div class="btn btn-primary btn-link">
                      <i
                        @click="openModal(det.id)"
                        v-tooltip.top-center="$i18n.t('verDesgloseDeImpuestos')"
                        class="fa fa-info-circle"
                      ></i>
                    </div>
                    <div class="btn btn-primary btn-link">
                      <i
                        @click="getDetTicketsById(det.id, det.idCode)"
                        v-tooltip.top-center="$i18n.t('verDetallesDetTicket')"
                        class="fa fa-eye text-primary"
                      ></i>
                    </div>
                    <div class="btn btn-primary btn-link text-success">
                      <a :href="urlExportTicketExcel(det.id)">
                        <i
                          v-tooltip.top-center="$i18n.t('exportarExcel')"
                          class="fa fa-file-excel text-success"
                        ></i
                      ></a>
                    </div>
                    <div class="btn btn-primary btn-link text-danger">
                      <a :href="urlExportTicketPDF(det.id)">
                        <i
                          v-tooltip.top-center="$i18n.t('exportarPdf')"
                          class="fa fa-file-pdf text-danger"
                        ></i>
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr></tr>
              </tfoot>
            </table>
          </div>

          <!-- ANTIGUO PAGINAR -->
          <!--<div class="row" v-if="!isSearch && totalPags > 1">
            <div class="col-md-12">
              <nav>
                <ul class="pagination flex-wrap">
                  <li class="page-item" :class="{ disabled: pag == 1 }">
                    <router-link
                      class="page-link"
                      :to="{ name: 'tickets', params: { pag: pag - 1 } }"
                      v-if="pag != 1"
                      >&laquo;
                    </router-link>
                    <span v-else class="page-link"
                      ><span aria-hidden="true">&laquo;</span></span
                    >
                  </li>
                  <li
                    class="page-item"
                    v-for="n in totalPags"
                    :class="{ active: n == pag }"
                  >
                    <router-link
                      class="page-link"
                      :to="{ name: 'tickets', params: { pag: n } }"
                      >{{ n }}
                    </router-link>
                  </li>
                  <li class="page-item" :class="{ disabled: pag == totalPags }">
                    <router-link
                      class="page-link"
                      :to="{ name: 'tickets', params: { pag: nextPag } }"
                      v-if="pag != totalPags"
                    >
                      &raquo;
                    </router-link>
                    <span v-else class="page-link"
                      ><span aria-hidden="true">&raquo;</span></span
                    >
                  </li>
                </ul>
              </nav>
            </div>
          </div>-->

          <div class="row overflow-auto">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalPags"
              :per-page="porPagina"
              :limit="7"
              last-number
            ></b-pagination>
          </div>

        </template>
        <template v-else>
          <div class="alert alert-danger" role="alert">
            {{ $t("noHayVentasEnEsteRangoDeFechas") }}
          </div>
        </template>
      </div>
    </div>

    <modal
      name="desgloseModal"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      :clickToClose="false"
    >
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("desgloseDeImpuestos") }}</h4>
        </div>
        <div class="modal-body">
          <div
            v-if="listDetallesCab.length > 0"
            class="table-responsive"
            style="overflow: auto"
          >
            <table class="table table-bordered table-striped ">
              <thead class="thead-dark">
                <tr>
                  <th>{{ $t("tipoIva") }}</th>
                  <th>{{ $t("base") }}</th>
                  <th>{{ $t("impuesto") }}</th>
                  <th>{{ $t("importe") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="ref in listDetallesCab">
                  <td>{{ ref.vatType }} %</td>
                  <td>{{ ref.base | currency }}</td>
                  <td>{{ ref.valor | currency }}</td>
                  <td align="right">{{ ref.amount | currency }}</td>
                </tr>
                <tr class="table-success">
                  <td>
                    <strong>{{ $t("total") }}:</strong>
                  </td>
                  <td></td>
                  <td></td>
                  <td align="right">
                    <strong>{{ totalDet | currency }}</strong>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr></tr>
              </tfoot>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" @click="cerrarModal()">
            <i class="fa fa-times-circle"></i>
            {{ $t("volver") }}
          </button>
        </div>
      </div>
    </modal>

    <modal
      name="desglose-ticket-modal"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      :clickToClose="false"
    >
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">
            {{ $t("desgloseDelTicket") }} {{ nameTickets }}
          </h4>
        </div>
        <div class="modal-body">
          <ticket :ticket="listDesgloseTicket"></ticket>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" @click="cerrarModal()">
            <i class="fa fa-times-circle"></i>
            {{ $t("volver") }}
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  Loading,
  DropdownMenu,
  Button,
   Switch,
} from "element-ui";
import swal from "sweetalert2";
import { mapState, mapMutations } from 'vuex';
import moment from "moment";
import Ticket from "../../../Widgets/Ticket.vue";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb.vue";
import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";

export default {
  created() {
    this.loading = Loading.service({ text: "Cargando..." });
    this.$store.dispatch("setNameRoute", this.$i18n.t("facturasSimplificadas"));
    if (!this.sectores && !this.$cookies.isKey("sectores")) {
      this.getBusiness();
    } else {
      if (this.listaSectores.length > 1) {

          this.idSector = this.listaSectores[0].id;

          //Dentro, establecer un todos como primera opción y después llamar a getTpv()
          this.getBusinessesBySector();
      } else {

          //Cargar método local donde me traigo los sectores
          this.getSectores();

      }
    }

    if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
      this.datefrom = this.$store.getters.dateFrom;
      this.dateto = this.$store.getters.dateTo;
    }
  },
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [Switch.name]: Switch,
    ticket: Ticket,
    Breadcrumb,
    CabeceraInformes,
  },
  data() {
    return {
      loading: false,
      datefrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ).toISOString(),
      dateto: new Date().toISOString(),
      listBusinesses: [],

      idBusiness: this.$route.params.idBusiness,

      data: [""],
      idTpv: 0,
      listTpv: [],
      idsTPV: [],
      value4: [
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        new Date(),
      ],
      cuentasAparcadas: false,
      dateInform: ["-"],
      searchQuery: this.$route.params.query,
      searchQueryLog: '',
      isSearch: this.$route.params.isSearch ? this.$route.params.isSearch : false,
      listDesgloseTicket: [],
      nameTickets: "",

      listTicketsSearch: [],
      listDetallesCab: [],

      //PAGINACION
      pag: this.$route.params.pag,
      totalPags: 0,
      porPagina: 0,
      currentPage: this.$route.params.pag ? this.$route.params.pag : 1,

      //ORDENAR
      ordenarFecha: 0,
      ordenarFactura: 0,
      ordenarTipo: 0,
      ordenarTotal: 0,
      ordenarBase: 0,
      ordenarImpuesto: 0,
      ordernarTotalSinDescuento:0,

      respuesta: true,

      checkValue: false,
      existeProducto: false,
    };
  },
  watch: {
    $route(to, from) {
      if (to.params.pag) {
        this.pag = to.params.pag;
        if(this.isSearch) {
          this.searchTickets();
        } else {
          this.getTickets();
        }
      } else if (to.params.query) {
        this.query = to.params.query;
        if(this.isSearch) {
          this.searchTickets();
        } else {
          this.getTickets();
        }
      }
    },
    currentPage() {
      this.$router.push({
        name: 'tickets', 
        params: {
          pag: this.currentPage
        },
      });
    }
  },
  computed: {
    ...mapState(["listaSectores", "sectores", "permiso"]),
    totalDet() {
      let total = 0;

      this.listDetallesCab.forEach(function(x) {
        total += x.amount;
      });

      return total;
    },

    urlExportPDF() {

      let idBusiness = this.idBusiness == -1 ? this.listaSectores[0].idBusinessMaster : this.idBusiness;
      let url = this.$store.getters.apiUrl +
        "/sales/exportTickets/PDF?idTpv=" +
        this.idsTPV +
        "&idBusiness=" +
        idBusiness +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&conDetalles=" +
        0+
        "&jwt=" +
        this.$store.getters.jwt + 
        "&checkValue=" + this.checkValue +
        "&simplificada=" + true;
      
      if (this.sectores && this.$cookies.isKey('sectores')) {
        url += "&sectores="+true;
      }
      
      return (
        url
      );
      
    },
    urlExportPDFconDetalles() {

      let idBusiness = this.idBusiness == -1 ? this.listaSectores[0].idBusinessMaster : this.idBusiness;
      let url = this.$store.getters.apiUrl +
        "/sales/exportTickets/PDF?idTpv=" +
        this.idsTPV +
        "&idBusiness=" +
        idBusiness +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&conDetalles=" +
        1+
        "&jwt=" +
        this.$store.getters.jwt +
        "&checkValue=" + this.checkValue + 
        "&simplificada=" + true;

      if (this.sectores && this.$cookies.isKey('sectores')) {
        url += "&sectores="+true;
      }
      
      return (
        url
      );
    },
    urlExportExcel() {

      let idBusiness = this.idBusiness == -1 ? this.listaSectores[0].idBusinessMaster : this.idBusiness;
      let url =  this.$store.getters.apiUrl +
        "/sales/exportTickets/Excel?idTpv=" +
        this.idsTPV +
        "&idBusiness=" +
        idBusiness +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&conDetalles=" +
        0+
        "&jwt=" +
        this.$store.getters.jwt +
        "&checkValue=" + this.checkValue +
        "&simplificada=" + true;

      if (this.sectores && this.$cookies.isKey('sectores')) {
        url += "&sectores="+true;
      }
      return (
        url
      );
    },
    urlExportExcelconDetalles() {

      let idBusiness = this.idBusiness == -1 ? this.listaSectores[0].idBusinessMaster : this.idBusiness;
      let url = this.$store.getters.apiUrl +
        "/sales/exportTickets/Excel?idTpv=" +
        this.idsTPV +
        "&idBusiness=" +
        idBusiness +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&conDetalles=" +
        1+
        "&jwt=" +
        this.$store.getters.jwt +
        "&checkValue=" + this.checkValue +
        "&simplificada=" + true;
      
      if (this.sectores && this.$cookies.isKey('sectores')) {
        url += "&sectores="+true;
      }

      return (url);
    },
    urlExportExcelCompleto() {

      let idBusiness = this.idBusiness == -1 ? this.listaSectores[0].idBusinessMaster : this.idBusiness;
      let url = this.$store.getters.apiUrl +
        "/sales/exportTickets/Excel?idTpv=" +
        this.idsTPV +
        "&idBusiness=" +
        idBusiness +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&conDetalles=" +
        0+
        "&completo=" +
        1+
        "&jwt=" +
        this.$store.getters.jwt +
        "&checkValue=" + this.checkValue +
        "&simplificada=" + true;;

      if (this.sectores && this.$cookies.isKey('sectores')) {
        url += "&sectores="+true;
      }

      return (
        url
      );
    },

    nextPag() {
      let nextPag = parseInt(this.pag) + 1;
      return nextPag;
    },
  },
  methods: {
    ...mapMutations(['changeListaSectores']),
    getSectores() {
      let config = {
          params: {
              jwt: this.$store.getters.jwt,
          },
          headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
      };

      let vm = this;
      this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesSectors", config)
          .then(function (response) {

          if (response.data.response) {
              
              response.data.result["sectores"].forEach((sector) => {
                  sector.idBusinessMaster = parseInt(sector.idBusinessMaster);
                  sector.id = parseInt(sector.id);
              });
              
              vm.changeListaSectores(response.data.result["sectores"]);

              vm.idSector = vm.listaSectores[0].id;
              
              vm.getBusinessesBySector();
              
          }

      }).catch(function (error) {
          console.log(error);
      })
    },
    getBusinessesBySector() {
      let config = {
          params: {
              jwt: this.$store.getters.jwt,
          },
          headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
      };

      var params = {
          idBusiness: this.listaSectores[0].idBusinessMaster,
          idSector: this.idSector,
          jwt: this.$store.getters.jwt,
      };

      let vm = this;
      this.axios.post(this.$store.getters.apiUrl + "general/getBusinessesBySector", params, config)
          .then(function (response) {

          if (response.data.response) {

              //Recojo todos los negocios de la carga inicial del sector seleccionado

              vm.listBusinesses = response.data.result;
              vm.idBusiness = -1;

              //Recojo todos los tpv
              vm.getAllTpvFromBusinesses();
              
          }

      }).catch(function (error) {
          console.log(error);
      })
    },
    getAllTpvFromBusinesses() {

      let businesses = [];

      this.listBusinesses.forEach(business => {

        if (business.id != -1) {
          businesses.push(parseInt(business.id));
        }
        
      });

      let config = {
          params: {
              jwt: this.$store.getters.jwt,
              idBusiness: businesses,
          },
          headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
      };

      let vm = this;
      this.axios.get(this.$store.getters.apiUrl + "general/getTpvsByListBusiness", config)
          .then(function (response) {

          if (response.data.response) {
              vm.listTpv = [];
              vm.idsTPV = [];
              for (let i = 0; i < response.data.result.length; i++) {
                vm.idsTPV.push(response.data.result[i].id);
              }

              for (let i = 0; i < response.data.result.length; i++) {
                let printername = {
                  nameShow: response.data.result[i].nameShow,
                  id: response.data.result[i].id,
                };

                vm.listTpv.push(printername);
              }

              vm.getTickets();
              vm.grafica = 0;
            }
            vm.loading.close();

      }).catch(function (error) {
          console.log(error);
      })
    },
    exportForm(formato, tipo) {
      let treinta_y_un_dias_en_segundos = 2678400;
      if((treinta_y_un_dias_en_segundos - (moment(this.dateto).startOf("day").unix() - moment(this.datefrom).startOf("day").unix())) > 0) {
        if(formato == "Excel") {
          if(tipo == "Simple") {
            window.open(this.urlExportExcel);
          } else if (tipo == "Detalles") {  
            window.open(this.urlExportExcelconDetalles);
          } else if (tipo == "Completo") {
            window.open(this.urlExportExcelCompleto);
          } 
        } else {
          if(tipo == "Simple") {
            window.open(this.urlExportPDF);
          } else if (tipo == "Detalles") {
            window.open(this.urlExportPDFconDetalles);
          }
        }
      } else {
        swal({
          title: this.$t("loSentimos"),
          text: this.$t("soloPuedesSacarInformesDeUnMesComoMaximo"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      }
    },
    totalImpuesto(ivas) {
      const totalSinDescuento = ivas.totalSinDescuento;
      const totalConDescuento = ivas.amount;

      const factorDescuento = totalConDescuento / totalSinDescuento;

      let totalIva = 0;

      ivas.ivas.forEach(function(x) {
        // Total de esta línea con descuento aplicado
        const totalLineaConDescuento = x.total * factorDescuento;

        // Base imponible ajustada
        const base = totalLineaConDescuento / ((x.iva + 100) / 100);

        // IVA ajustado
        const iva = totalLineaConDescuento - base;

        totalIva += iva;
      });

      return totalIva;
    },

    calculateTotal(ivas) {
      let total = 0;

      ivas.ivas.forEach(function(x) {
        total += x.total;
      });
      
      return total;
    },

    totalBase(ivas) {
      var total = 0;

      ivas.ivas.forEach(function(x) {
        total += x.total / ((x.iva + 100) / 100);
      });

      return total;
    },

    sortedArrayASC: function(nameAtributo, index) {
      switch (nameAtributo) {
        case 1:
          this.ordenarFecha = 1;

          function compareDate(a, b) {
            if (a.date.toUpperCase() < b.date.toUpperCase()) return -1;
            if (a.date.toUpperCase() > b.date.toUpperCase()) return 1;
            return 0;
          }

          return this.dateInform[index].headers.sort(compareDate);

        case 2:
          this.ordenarFactura = 1;

          function compareFactura(a, b) {
            if (a.idCode.toUpperCase() < b.idCode.toUpperCase()) return -1;
            if (a.idCode.toUpperCase() > b.idCode.toUpperCase()) return 1;
            return 0;
          }

          return this.dateInform[index].headers.sort(compareFactura);

        case 3:
          this.ordenarTipo = 1;

          function compareTipo(a, b) {
            if (a.status.toUpperCase() < b.status.toUpperCase()) return -1;
            if (a.status.toUpperCase() > b.status.toUpperCase()) return 1;
            return 0;
          }

          return this.dateInform[index].headers.sort(compareTipo);

        case 4:
          this.ordenarTotal = 1;

          function compareTotal(a, b) {
            if (a.amount < b.amount) return -1;
            if (a.amount > b.amount) return 1;
            return 0;
          }

          return this.dateInform[index].headers.sort(compareTotal);

          case 5:
          this.ordernarTotalSinDescuento = 1;

          function compareTotal(a, b) {
            if (a.totalSinDescuento < b.totalSinDescuento) return -1;
            if (a.totalSinDescuento > b.totalSinDescuento) return 1;
            return 0;
          }

          return this.dateInform[index].headers.sort(compareTotal);
      }
    },
    sortedArrayDESC: function(nameAtributo, index) {
      switch (nameAtributo) {
        case 1:
          this.ordenarFecha = 0;

          function compareDate(a, b) {
            if (a.date.toUpperCase() > b.date.toUpperCase()) return -1;
            if (a.date.toUpperCase() < b.date.toUpperCase()) return 1;
            return 0;
          }

          return this.dateInform[index].headers.sort(compareDate);

        case 2:
          this.ordenarFactura = 0;

          function compareFactura(a, b) {
            if (a.idCode.toUpperCase() > b.idCode.toUpperCase()) return -1;
            if (a.idCode.toUpperCase() < b.idCode.toUpperCase()) return 1;
            return 0;
          }

          return this.dateInform[index].headers.sort(compareFactura);

        case 3:
          this.ordenarTipo = 0;

          function compareTipo(a, b) {
            if (a.status.toUpperCase() > b.status.toUpperCase()) return -1;
            if (a.status.toUpperCase() < b.status.toUpperCase()) return 1;
            return 0;
          }

          return this.dateInform[index].headers.sort(compareTipo);

        case 4:
          this.ordenarTotal = 0;

          function compareTotal(a, b) {
            if (a.amount > b.amount) return -1;
            if (a.amount < b.amount) return 1;
            return 0;
          }

          return this.dateInform[index].headers.sort(compareTotal);

        case 5:
          this.ordernarTotalSinDescuento = 0;

          function compareTotal(a, b) {
            if (a.totalSinDescuento > b.totalSinDescuento) return -1;
            if (a.totalSinDescuento < b.totalSinDescuento) return 1;
            return 0;
          }

          return this.dateInform[index].headers.sort(compareTotal);
      }
    },
    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function(response) {
          vm.listBusinesses = response.data.result;

          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }

          vm.cambioTpv(-1, false);
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    openModal(idHeader) {
      this.getTicketsDet(idHeader);

      this.$modal.show("desgloseModal");
    },

    cerrarModal() {
      this.$modal.hide("desgloseModal");
      this.$modal.hide("desglose-ticket-modal");
    },

    getTicketsDet(idHeader) {
      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$t("ups"),
          text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        let secondsDesde = moment(this.datefrom)
          .startOf("day")
          .unix();
        let secondsHasta = moment(this.dateto)
          .endOf("day")
          .unix();

        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$t("ups"),
            text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        } else {
          this.$store.dispatch("setDateTo", this.dateto);
          this.$store.dispatch("setDateFrom", this.datefrom);

          this.loading = Loading.service({ text: "Cargando..." });

          const controller = "getTicketsDetailsById";

          var config = {
            params: {
              idBusiness: this.idBusiness,
              idHeader: idHeader,
              jwt: this.$store.getters.jwt,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };

          let vm = this;
          this.$store.dispatch("setIdBusiness", this.idBusiness);
          this.axios
            .get(this.$store.getters.apiUrl + "sales/" + controller, config)
            .then(function(response) {
              if (response.data.response) {
                vm.listDetallesCab = response.data.result;
              } else {
                swal({
                  title: vm.$t("atencion"),
                  text: response.data.result,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });
              }
              vm.loading.close();
            })
            .catch(function(error) {
              console.log(error);
            });
        }
      }
    },

    cambioBusiness(idBusinessData, listTpv) {
      if (listTpv) {
        this.listTpv = listTpv;
      }
      this.loading = Loading.service({ text: "Cargando..." });
      this.idBusiness = idBusinessData;
      this.idTpv = -1;
      this.idsTPV = [];

      if ((!this.sectores && !this.$cookies.isKey("sectores")) || idBusinessData != -1) {
        this.getTpv();
      } else {
        this.getAllTpvFromBusinesses();
      }
    },
    emitirConsulta() {
      if(this.isSearch) {
        this.searchTickets();
      } else {
        this.getTickets();
      }
    },
    cambioSector(idSectorData, listBusinesses) {

      if (listBusinesses) {
        this.listBusinesses = listBusinesses;
      }

      this.idSector = idSectorData;
      this.idBusiness = -1; 
      this.getAllTpvFromBusinesses();
    },
    cambioTpv(idTpvData, filtrar) {
      if (idTpvData != undefined) {
        this.idTpv = idTpvData;
        this.changeTPV();
      }
      this.isSearch = false;
      this.searchQuery = '';
      this.emitirConsulta();
    },
    cambioHora(dates) {
      this.datefrom = dates[0];
      this.dateto = dates[1];
    },
    changeTPV() {
      if (this.idTpv === -1) {
        this.idsTPV = [];

        for (let i = 0; i < this.listTpv.length; i++) {
          this.idsTPV.push(this.listTpv[i].id);
        }
      } else {
        this.idsTPV = [];
        this.idsTPV.push(this.idTpv);
      }

    },
    getTpv() {
      this.listTpv = [];

      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
        .then(function(response) {
          if (response.data.response) {

            for (let i = 0; i < response.data.result.length; i++) {
                vm.idsTPV.push(response.data.result[i].id);
            }

            vm.listTpv = response.data.result;

            vm.getTickets();
          }
        })
        .catch(function(error) {
          console.log(error);
        })
        .finally((_) => {
          vm.loading.close();
        });
    },

    getTickets() {
      if (this.idsTPV.length > 0) {
        if (this.datefrom === null || this.dateto === null) {
          swal({
            title: this.$t("ups"),
            text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        } else {
          let secondsDesde = moment(this.datefrom)
            .startOf("day")
            .unix();
          let secondsHasta = moment(this.dateto)
            .endOf("day")
            .unix();

          if (secondsHasta < secondsDesde) {
            swal({
              title: this.$t("ups"),
              text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          } else {
            this.$store.dispatch("setDateTo", this.dateto);
            this.$store.dispatch("setDateFrom", this.datefrom);

            this.loading = Loading.service({ text: "Cargando..." });
            const controller = "getTickets";

            if(this.isSearch) {
              this.pag = 1;
            }
            this.isSearch = false;
            this.searchQuery = '';

            var config = {
              params: {
                idTpv: this.idsTPV,
                idBusiness: this.idBusiness == -1 ? this.listaSectores[0].idBusinessMaster : this.idBusiness,
                sectores: this.sectores,
                simplificada: true,
                pag: this.pag,
                datefrom: moment(this.datefrom)
                  .startOf("day")
                  .unix(),
                dateto: moment(this.dateto)
                  .endOf("day")
                  .unix(),
                checkValue : this.checkValue,
                jwt: this.$store.getters.jwt,
              },
              headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            this.$store.dispatch("setIdBusiness", this.idBusiness);
            this.axios
              .get(this.$store.getters.apiUrl + "sales/" + controller, config)
              .then(function(response) {
                if (response.data.response) {
                  vm.respuesta = true;

                  vm.dateInform = response.data.result.tickets;
                  vm.pag = response.data.result.pag;
                  vm.totalPags = response.data.result.totalPags;

                  // console.log("dateInform");
                  // console.log(vm.dateInform);
                  // console.log("data.result.tickets");
                  // console.log(response.data.result.tickets);

                  vm.porPagina = 1;
                  vm.existeProducto = response.data.result.existeProducto
                }else if (response.data.response == false && response.data.rangoMayor == true) {
                      swal({
                        title: "Lo sentimos",
                        text: response.data.result,
                        confirmButtonClass: "btn btn-info btn-fill",
                        type: "info",
                      });
                      vm.respuesta = false;
                }  else {
                  swal({
                    title: vm.$t("atencion"),
                    text: response.data.message,
                    confirmButtonClass: "btn btn-info btn-fill",
                    type: "error",
                  });

                  vm.respuesta = false;
                }
                vm.loading.close();
              })
              .catch(function(error) {
                console.log(error);
              });
          }
        }
      }
    },

    searchTickets() {
      this.loading = Loading.service({ text: "Cargando..." });

      const controller = this.searchQuery
        ? "searchTicketsByBusiness/" + this.searchQuery
        : "getTickets";

      if(!this.isSearch) {
        this.pag = 1;
      }

      if(this.searchQueryLog != this.searchQuery) {
        this.pag=1;
      }

      this.searchQueryLog = this.searchQuery;

      var config = {
        params: {
          idBusiness: this.idBusiness == -1 ? this.listaSectores[0].idBusinessMaster : this.idBusiness,
          idTpv: this.idTPV,
          pag: this.pag,
          datefrom: moment(this.datefrom)
            .startOf("day")
            .unix(),
          dateto: moment(this.dateto)
            .endOf("day")
            .unix(),
          checkValue:this.checkValue,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(this.$store.getters.apiUrl + "sales/" + controller, config)
        .then(function(response) {
          if (response.data.response) {
            vm.dateInform = response.data.result.tickets;
            vm.pag = response.data.result.pag;
            vm.totalPags = response.data.result.totalPags;
            vm.porPagina = 1;
            vm.isSearch = true;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.result,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
          vm.loading.close();
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    getDetTicketsById(idHeader, name) {
      this.listDesgloseTicket = [];
      this.nameTickets = name;

      this.loading = Loading.service({ text: "Cargando..." });

      var config = {
        params: {
          idBusiness: this.idBusiness,
          idHeader: idHeader,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "sales/getDetTicketsById", config)
        .then(function(response) {
          if (response.data.response) {
            vm.listDesgloseTicket = response.data.result[0];
            vm.$modal.show("desglose-ticket-modal");
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.result,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
          vm.loading.close();
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    getClassDay(date) {
      var classDay = "";
      var humanDate = moment.unix(date);
      var dia = moment(humanDate).format("d");

      if (dia === "0") {
        classDay = "sunday";
      } else if (dia == 5 || dia == 6) {
        classDay = "fridaySaturday";
      }

      return classDay;
    },

    urlExportTicketPDF(idHeader) {
      return (
        this.$store.getters.apiUrl +
        /*"/sales/exportTicket/PDF?idBusiness=" +*/
        "/sales/exportFacturasEmitidaById/PDF?idBusiness=" +
        this.idBusiness +
        "&idHeader=" +
        idHeader +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportTicketExcel(idHeader) {
      return (
        this.$store.getters.apiUrl +
        "/sales/exportTicket/Excel?idBusiness=" +
        this.idBusiness +
        "&idHeader=" +
        idHeader +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
  },
};
</script>

<style scoped>
a li {
  color: #111;
}

.card {
  padding: 20px;
}

.div-export {
  margin-bottom: 10px;
}

.sunday {
  color: rgb(128, 0, 0);
}

.fridaySaturday {
  color: rgb(0, 128, 64);
}

</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Ventas/Tickets.vue